module.exports = __webpack_public_path__ + "img/microfone-em-fundo-desfocado.jpg";